import { Drawer, DrawerContent, DrawerTitle } from '../ui/drawer';
import { Sheet, SheetContent, SheetTitle } from '../ui/sheet';
import { cn } from '@/client/utils';
import type { PropsWithChildren } from 'react';
import useMedia from 'react-use/lib/useMedia';

type DrawerSheetTitleProps = PropsWithChildren & {
  className?: string;
};

export const DrawerSheetTitle = ({ className, children }: DrawerSheetTitleProps) => {
  const isDesktop = useMedia('(min-width: 768px)');
  if (isDesktop) return <SheetTitle className={className}>{children}</SheetTitle>;
  return <DrawerTitle className={className}>{children}</DrawerTitle>;
};

type DrawerSheetProps = PropsWithChildren & {
  className?: string;
  side?: 'top' | 'bottom' | 'left' | 'right' | null | undefined;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  disableOutside?: boolean;
};
export const DrawerSheet = ({ open, setOpen, children, className, side = 'right', disableOutside }: DrawerSheetProps) => {
  const isDesktop = useMedia('(min-width: 768px)');
  const onInteractOutside = disableOutside ? (e: any) => e.preventDefault() : undefined;
  if (isDesktop) {
    return (
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side={side}
          aria-describedby={undefined}
          onInteractOutside={onInteractOutside}
          onOpenAutoFocus={e => e.preventDefault()}
          className="gap-0 p-0 w-auto border-foreground/10 block sm:max-w-none bg-background"
        >
          <div className={cn('p-5 h-full overflow-y-auto', className)}>{children}</div>
        </SheetContent>
      </Sheet>
    );
  }
  return (
    <Drawer open={open} onOpenChange={setOpen} repositionInputs={false}>
      <DrawerContent
        aria-describedby={undefined}
        onInteractOutside={onInteractOutside}
        onOpenAutoFocus={e => e.preventDefault()}
        className="w-full max-h-[calc(100%-52px)]"
      >
        <div className={cn('px-5 pb-5 h-full overflow-y-auto', className)}>{children}</div>
      </DrawerContent>
    </Drawer>
  );
};
